import type { JSX } from "react";
import { view } from "../../lib/vvm";
import styles from "./VirtualizedChunks.module.css";
import {
  VirtualizedChunksViewModel,
  type VirtualizedChunksProps,
} from "./VirtualizedChunksViewModel";

const VirtualizedChunksBase = view<VirtualizedChunksViewModel>(
  VirtualizedChunksViewModel,
)<VirtualizedChunksProps<unknown>>(({
  viewModel,
  renderChunk,
  className,
  contentClassName,
}) => {
  return (
    <div
      ref={viewModel.rootRef}
      className={`${styles.root} ${className || ""}`.trim()}
    >
      <div
        className={styles.spacer}
        style={{ height: viewModel.topSpacerHeight }}
      />
      <div className={`${styles.content} ${contentClassName || ""}`.trim()}>
        {viewModel.visibleChunkIds.map((chunkId) => (
          <div
            key={chunkId}
            ref={(node) => {
              viewModel.setChunkRef(chunkId, node);
            }}
          >
            {renderChunk(chunkId, viewModel.chunks[chunkId] || [])}
          </div>
        ))}
      </div>
      {viewModel.isLoadingMore && (
        <div className={styles.loading}>{viewModel.loadingLabel}</div>
      )}
      <div
        className={styles.spacer}
        style={{ height: viewModel.bottomSpacerHeight }}
      />
    </div>
  );
});

export const VirtualizedChunks = <T,>(
  props: VirtualizedChunksProps<T>,
): JSX.Element => (
  <VirtualizedChunksBase {...(props as VirtualizedChunksProps<unknown>)} />
);
